export const normalizeStr = (str) =>
  // More or less mimic TagName.clean behavior less canvas extraction.
  // Replaces hyphens with spaces to align with Autocomplete.js searchEngine
  // matching. See app/models/tag_name.rb for TagName.clean implementation.
  // See https://github.com/TarekRaafat/autoComplete.js/blob/master/src/controllers/searchController.js#L19
  // for Autocomplete.js searchEngine matching.
  str
    .toLowerCase()
    .replace(/-+/g, ' ')
    .replace(/[^a-z0-9\s]/gi, '')
    .trim();

export const keepAlphaOnly = (inputValue) => {
  // Remove all non-alphanumeric characters (including blanks, punctuation, and non-ASCII characters)
  return inputValue.replace(/[^a-z0-9]/gi, '');
};
